<template>
  <div
    class="post-top-container"
    :class="postTopClass"
  >
    <div
      v-if="isPostWithImage"
    >
      <img
        :src="post.image_url || imagePlaceHolder"
        alt="Imagem da publicação"
        class="post-top-image"
        @error="imageLoadOnError"
      >
    </div>

    <div class="social-icon-profile-img-aaa">
      <div class="social-icon">
        <a
          :href="post.post_url"
          target="_blank"
        >
          <component
            :is="getChannelComponent(post.primaryChannel || post.primary_channel || post.channel)"
            :channel="post.primaryChannel || post.primary_channel || post.channel"
          />
        </a>
      </div>

      <div class="profile-img">
        <StUserAvatar
          :user="user"
          size="100"
        />
      </div>

      <div class="aaa">
        <div>
          AAA {{ userScore }}
        </div>
      </div>
    </div>

    <div class="name-date">
      <div class="name text-truncate">
        {{ post.name }}
      </div>

      <div class="date">
        {{ post.posted_at }}
      </div>
    </div>
  </div>
</template>

<script>
import StUserAvatar from '@stilingue/st-user-avatar';
import { findSocialIcon } from '@/utils/channels';

export default {
  name: 'PostTop',
  components: {
    StUserAvatar,
  },
  props: {
    post: {
      type: Object,
      required: true,
    },
    isPostWithImage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imagePlaceHolder: 'https://placehold.it/332x121',
    };
  },
  computed: {
    user() {
      return {
        userId: this.post.long_posted_at,
        name: this.post.username || this.post.name,
        img: this.post.user_image_url,
      };
    },
    postTopClass() {
      return {
        'post-top-type--image': this.isPostWithImage,
        'post-top-type--regular': !this.isPostWithImage,
      };
    },
    userScore() {
      return this.post.user_score <= 0 ? 0 : Math.ceil(this.post.user_score * 100);
    },
  },
  methods: {
    getChannelComponent(channel) {
      return findSocialIcon(channel);
    },
    imageLoadOnError() {
      this.post.image_url = this.imagePlaceHolder;
    },
  },
};
</script>

<style scoped lang="scss">
  .post-top-container {
    display: grid;
    grid-template-columns: 1fr;
  }

  .aaa,
  .social-icon {
    display: grid;
    align-content: center;
    font-size: 14px;
  }

  .social-icon {
    justify-self: flex-start;
  }

  .aaa {
    font-size: 10px;
    justify-self: flex-end;
    color: var(--gray-300);
    font-weight: bold;
    margin-right: 20px;
  }

  .profile-img {
    display: grid;
    justify-items: center;
    align-content: center;
    border-radius: 100%;

    @media screen and (min-width: 601px) {
      .v-avatar {
        height: 100px !important;
        width: 100px !important;
        border: 2px solid white;
      }
    }
  }

  .post-top-image {
    width: 100%;
    height: 131px;
    object-fit: cover;
    object-position: center;
  }

  .social-icon-profile-img-aaa {
    display: grid;
    grid-template-rows: 100%;
    grid-template-columns: 35% auto 35%;
    justify-items: center;
    align-content: center;
  }

  .post-top-type--regular {
    grid-template-rows: 123px auto;

    .social-icon {
      span {
        margin-left: 20px;
      }
    }
  }

  .post-top-type--image {
    grid-template-rows: 130px 100px 45px;

    .social-icon {
      margin-top: 20px;

      span {
        margin-left: 20px;
      }
    }

    .aaa {
      margin-top: 15px;
    }

    .social-icon-profile-img-aaa {
      position: relative;
      top: -30px;
    }

    .name-date {
      position: relative;
      top: -20px;
    }
  }

  .name {
    width: 80%;
    margin: 0 auto;
    text-align: center;
    height: 24px;
    font-size: 18px;
  }

  .date {
    height: 14px;
    font-size: 10px;
    text-align: center;
  }

  @media screen and (max-width: 600px) {
    .v-avatar {
      height: 48px !important;
      min-width: 48px !important;
      width: 48px !important;
    }

    .social-icon-profile-img-aaa {
      width: 200px;
    }

    .name-date {
      width: 200px;
    }
  }

</style>
